import styled from "styled-components";

export const TooltipWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: visible;
  z-index: 1;
`;

export const Icon = styled.div`
  width: 24px;
  height: 24px;
  border: 2px solid #a0a0a0;
  border-radius: 50%;
  color: ${({ theme }) => theme.colors.default[50]};
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  line-height: 20px;
  cursor: pointer;
  user-select: none;
`;

export const TooltipBubble = styled.div`
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.3s ease;

  position: absolute;
  left: 36px;
  top: 50%;
  transform: translateY(-50%);
  background-color: ${({ theme }) => theme.colors.default[800]};
  color: white;
  padding: 12px 14px;
  border-radius: 12px;
  width: max-content;
  max-width: 240px;
  font-size: 14px;
  white-space: pre-line;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 10;

  &::before {
    content: "";
    position: absolute;
    top: 50%;
    left: -6px;
    transform: translateY(-50%);
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 6px 6px 6px 0;
    border-color: transparent ${({ theme }) => theme.colors.default[900]}
      transparent transparent;
  }

  ${TooltipWrapper}:hover & {
    visibility: visible;
    opacity: 1;
    z-index: 10;
  }

  @media (hover: none) and (pointer: coarse) {
    ${TooltipWrapper}:active {
      visibility: visible;
      opacity: 1;
    }
  }

  ${({ theme }) => theme.breakpoints.md.query} {
    right: 50%;
    top: auto;
    bottom: calc(100% + 8px); /* 8px space above the icon */
    transform: translateX(-50%);
    max-width: 38vw;
    white-space: normal;
    left: -15px;

    &::before {
      top: 100%;
      left: 65%;
      transform: translateX(-50%);
      border-width: 6px 6px 0 6px;
      border-color: ${({ theme }) => theme.colors.default[900]} transparent
        transparent transparent;
    }
  }
`;
